module.exports = {"441422100":"湖寮镇","441422103":"青溪镇","441422105":"三河镇","441422108":"银江镇","441422109":"洲瑞镇","441422112":"光德镇","441422113":"桃源镇","441422116":"百侯镇","441422117":"大东镇","441422121":"大麻镇","441422122":"枫朗镇","441422123":"茶阳镇","441422124":"高陂镇","441422125":"西河镇","441422400":"丰溪林场","441422401":"洲瑞林场","441422402":"大埔林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441422.json
// module id = 1852
// module chunks = 0